import { render, staticRenderFns } from "./editorswitch.vue?vue&type=template&id=1aec2bf2&scoped=true&"
import script from "./editorswitch.vue?vue&type=script&lang=js&"
export * from "./editorswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec2bf2",
  null
  
)

export default component.exports